export const REDIRECT_TIMEOUT_IN_SECONDS = 1

export const PHONE_LENGTH = 11

export const USERNAME_MAX_LENGTH = 80

export const REGISTER_ICON_VARIATION = 'brand'

export const PLURALL_DOMAINS = [
  '.s.plurall.net',
  '.e.plurall.net',
  '.d.plurall.net',
  '.plurall.net',
]

export const SESSION_STORAGE_KEY = 'plurall-login-menu'

export const SESSION_STORAGE_OAUTH_EMAIL = 'oauthEmail'

export const LOCAL_STORAGE_ERROR_EMAIL_OAUTH = 'errorEmailOauth'

export const TUTOR_ROLE_ID = '2'
